<template>
  <div v-if="jurisdictions.length > 0" class="viq-upsell-jur">
    <div class="viq-upsell-jur__header">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.2" />
        <path d="M7 4v3M7 9h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      <span>Additional coverage available</span>
    </div>
    <p class="viq-upsell-jur__text">
      Relevant content was found in
      <strong>{{ jurisdictions.join(', ') }}</strong>
      — not included in your current subscription.
    </p>
    <div class="viq-upsell-jur__actions">
      <button
        v-if="!interested"
        class="viq-upsell-jur__btn"
        @click="expressInterest"
      >I'm interested in upgrading</button>
      <span v-else class="viq-upsell-jur__confirmed">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 6l2.5 2.5 4.5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Thanks — we'll be in touch
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqUpsellJurisdictions",
  props: {
    jurisdictions: {
      type: Array,
      required: true,
    },
    context: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      interested: false,
    };
  },
  methods: {
    expressInterest() {
      this.jurisdictions.forEach((jur) => {
        this.$store.dispatch("Viq/recordUpsellInterest", {
          type: "jurisdiction",
          value: jur,
          context: this.context,
        });
      });
      this.interested = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-upsell-jur {
  margin-top: $viq-space-md;
  padding: $viq-space-md;
  background: $viq-upsell-bg;
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: $viq-radius-md;

  &__header {
    display: flex;
    align-items: center;
    gap: $viq-space-sm;
    font-size: $viq-font-sm;
    font-weight: 700;
    color: #92400e;
    margin-bottom: $viq-space-xs;
  }

  &__text {
    font-size: $viq-font-sm;
    color: #78350f;
    line-height: 1.5;
    margin: 0 0 $viq-space-sm;
  }

  &__actions {
    display: flex;
    align-items: center;
  }

  &__btn {
    padding: $viq-space-xs $viq-space-md;
    background: #92400e;
    color: #fff;
    border: none;
    border-radius: $viq-radius-md;
    font-size: $viq-font-xs;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: #78350f;
    }
  }

  &__confirmed {
    display: flex;
    align-items: center;
    gap: $viq-space-xs;
    font-size: $viq-font-xs;
    font-weight: 600;
    color: $viq-success;
  }
}
</style>
